import videoPopupSeen from './videoPopupSeen';

export default {
  videoPopupSeen,
};
